namespace RedBullMOBILE360.Web.Models {
    export interface ArqamiRequest {
        UserId?: string;
    }
}
